/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from 'react';
import { LocalHeaderAccuWeatherProps } from '../LocalHeader.types';
import { AccuWeather } from '../../AccuWeather';
import { experienceFragmentComponentTypes } from '../../../modules/utils/constants/constants';

export const LocalHeaderAccuWeather: FC<LocalHeaderAccuWeatherProps> = ({
  cqItems,
  cqItemsOrder,
  showAccuWeatherInL1 = false,
  isAuthorMode,
}): JSX.Element => {
  //Method for returning components to be rendering at end point URL
  const AccuWeatherContainerWrapper = (cardName: string, jsonData: any) => {
    const returnable: Array<any> = [];
    // eslint-disable-next-line no-prototype-builtins
    if (jsonData?.hasOwnProperty(cardName)) {
      const card = jsonData[cardName];
      const cardItems = card[':items'];
      for (const itemKey in cardItems) {
        // eslint-disable-next-line no-prototype-builtins
        if (cardItems?.hasOwnProperty(itemKey)) {
          const item = cardItems[itemKey];
          if (item[':type'] === experienceFragmentComponentTypes.accuWeather) {
            returnable.push(<AccuWeather {...item} showAccuWeatherInL1={showAccuWeatherInL1} />);
          } else {
            for (const i in item?.[':items']) {
              for (const j in item?.[':items']?.[i]) {
                for (const k in item?.[':items']?.[i]?.[j]) {
                  for (const l in item?.[':items']?.[i]?.[j]?.[k]) {
                    for (const m in item?.[':items']?.[i]?.[j]?.[k]?.[l]) {
                      const obj = item?.[':items']?.[i]?.[j]?.[k]?.[l]?.[m];
                      if (obj[':type'] === experienceFragmentComponentTypes.accuWeather) {
                        returnable.push(
                          <AccuWeather {...obj} showAccuWeatherInL1={showAccuWeatherInL1} isAuthorMode={isAuthorMode} />
                        );
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      return <div data-testid="brand-container-component-wrapper">{returnable}</div>;
    }
    return null;
  };

  const showAccuWeatherContainer: JSX.Element = (
    <div>{cqItemsOrder && AccuWeatherContainerWrapper(cqItemsOrder?.[0], cqItems)}</div>
  );

  return showAccuWeatherContainer;
};
